import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';
import Header from './components/Header';
import DealsTab from './components/DealsTab';
import RecipesTab from './components/RecipesTab';
import FavoritesTab from './components/FavoritesTab';
import ShoppingListTab from './components/ShoppingListTab';
import LoginTab from './components/LoginTab';
import PrivateRoute from './components/PrivateRoute';
import { createClient } from '@supabase/supabase-js';

// Trigger deployment - small code change for testing

// Initialize Supabase client
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const checkUser = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        setCurrentUser(session?.user || null);
      } catch (error) {
        console.error('Error checking user:', error);
      } finally {
        setLoading(false);
      }
    };

    checkUser();

    // Listen for auth state changes
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      setCurrentUser(session?.user || null);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Header currentUser={currentUser} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/deals" />} />
            <Route path="/login" element={<LoginTab />} />
            <Route
              path="/deals"
              element={
                <PrivateRoute currentUser={currentUser} loading={loading}>
                  <DealsTab currentUser={currentUser} />
                </PrivateRoute>
              }
            />
            <Route
              path="/recipes"
              element={
                <PrivateRoute currentUser={currentUser} loading={loading}>
                  <RecipesTab currentUser={currentUser} />
                </PrivateRoute>
              }
            />
            <Route
              path="/favorites"
              element={
                <PrivateRoute currentUser={currentUser} loading={loading}>
                  <FavoritesTab currentUser={currentUser} />
                </PrivateRoute>
              }
            />
            <Route
              path="/shopping-list"
              element={
                <PrivateRoute currentUser={currentUser} loading={loading}>
                  <ShoppingListTab currentUser={currentUser} />
                </PrivateRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;